import React, { useContext, useMemo } from "react"
import lodash from "lodash"
import styled from "styled-components"
import i18n from "components/Translation/i18n"

import Select from "components/Select"
import { useCustomer } from "components/Customer"

const Wrapper = styled.div`
  min-width: 300px;
`

const CustomerSelect = props => {
  const { currentCustomer, customers, changeCustomer } = useCustomer()

  const options = useMemo(
    () =>
      customers.map(c => ({
        label: lodash.get(c, "postaladdress.name1"),
        value: lodash.get(c, "id")
      })),
    [customers]
  )

  const selectProps = {}
  const isDisabled = lodash.get(customers, "length", 0) === 1
  if (isDisabled) {
    selectProps.arrowRenderer = null
    selectProps.disabled = true
  }

  return (
    <Wrapper>
      <Select
        {...selectProps}
        simpleValue
        slim={isDisabled}
        isDisabled={isDisabled}
        value={lodash.get(currentCustomer, "id")}
        onChange={changeCustomer}
        options={options}
        searchable={true}
        clearable={false}
        autosize
        // valueRenderer={renderValue}
        direct
        valuePrefix={`${i18n.t("Benutzerkennung", "Benutzerkennung")}:`}
      />
    </Wrapper>
  )
}

export default CustomerSelect
